import type { BusinessEntity, PipelineClient } from '../types/onboarding'
import { createEmptyEntity } from '../lib/factories'

/** Fictional demo client. Stands in for a multi-entity client (e.g. the Venbrook example from the call). */
export const MOCK_CLIENT_NAME = 'Acme Specialty Group'
export const MOCK_ASSIGNED_COORDINATOR = 'Teri Blackshear (MISC)'
export const SUPPORT_EMAIL = 'onboarding@morrisisc.com'

/**
 * Entity shells MISC enters when setting up the client (name + NPN only, per the call — no PDB preload).
 * The client completes the remaining Business Entity Setup fields.
 */
export function createSeedEntities(): BusinessEntity[] {
  return [
    createEmptyEntity('MISC', { name: 'Acme Specialty Brokerage LLC', npn: '18844201' }),
    createEmptyEntity('MISC', { name: 'Acme E&S Insurance Services Inc.', npn: '19920377' }),
    createEmptyEntity('MISC', { name: 'Harbor Point Excess Underwriters LLC', npn: '20175563' }),
  ]
}

export const MOCK_PIPELINE: PipelineClient[] = [
  {
    clientId: 'C-1002',
    clientName: 'Northwind Excess Partners',
    dateStarted: '2026-09-08',
    percentComplete: 64,
    dateSubmitted: null,
    assignedCoordinator: 'Teri Blackshear (MISC)',
  },
  {
    clientId: 'C-1003',
    clientName: 'Contoso Risk Advisors Inc.',
    dateStarted: '2026-08-25',
    percentComplete: 100,
    dateSubmitted: '2026-09-15',
    assignedCoordinator: 'Sylvia Blackshear (MISC)',
  },
  {
    clientId: 'C-1004',
    clientName: 'Fabrikam Coastal Group',
    dateStarted: '2026-09-01',
    percentComplete: 18,
    dateSubmitted: null,
    assignedCoordinator: 'Teri Blackshear (MISC)',
  },
]
